import {connect} from 'react-redux';
import CoverPageLayout from './CoverPageLayout';
import CoverImages from '../lib/CoverImages';
import {findSection} from '../ducks/reportSections';
import {get} from 'lodash';
import format from 'dateformat';


function coverFieldIsEnabled(
  state, field,
  coverPage = findSection(state.reportSections, state.reportType.value, 'COVER_PAGE')
) {
  return get(coverPage, `sectionData.${field}_isEnabled`, 'true') === 'true';
}

const coverField = (state, field, enabledDefault) => {
  const coverPage = findSection(state.reportSections, state.reportType.value, 'COVER_PAGE');
  if (coverFieldIsEnabled(state, field, coverPage)) {
    return coverPage.sectionData[field] || enabledDefault;
  }
  return null;
};

const fullName = (firstName, lastName) => {
  return [firstName, lastName].join(' ');
};

const stateToProps = (state, ownProps) => ({
  address: coverField(state, 'singleLineAddress', state.propertyDetail.singleLineAddress),
  agencyLogo: coverField(state, 'agencyLogo', state.userDetails.agencyLogoUri),
  agent: {
    name: coverField(state, 'agentName', fullName(get(state, 'userDetails.firstName'), get(state, 'userDetails.lastName'))),
    photo: coverField(state, 'agentPhoto', state.userDetails.photo),
    tradeName: coverField(state, 'agency', state.userDetails.tradeName),
    address1: coverField(state, 'agencyAddress', fullName(get(state, 'userDetails.address1'), get(state, 'userDetails.address2'))),
    address2: coverField(state, 'agencyAddress2', [
      get(state, 'userDetails.suburb'),
      get(state, 'userDetails.state'),
      get(state, 'userDetails.postalCode'),
    ].filter(v => v).join(' ')),
    workPhone: coverField(state, 'landline', state.userDetails.workPhoneNumber),
    mobilePhone: coverField(state, 'mobile', state.userDetails.workMobileNumber),
    workEmail: coverField(state, 'email', state.userDetails.workEmail),
  },
  colour: state.theme.colour,
  imageUri: (CoverImages.selectedImage(state) || {}).src,
  name: 'half',
  showButton: false,
  preparedFor: coverField(state, 'preparedFor') || null,
  preparedOn: coverField(state, 'preparedOn', format(new Date(), 'dS mmmm yyyy')) || null,
  title: coverField(state, 'title'),
  cropCoverImage: CoverImages.shouldCropCoverImage(state, ownProps.name, ownProps.imageUri),
  ...ownProps,
});

export default connect(stateToProps)(CoverPageLayout);